var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { MessageBar, MessageBarType, PrimaryButton } from '@fluentui/react';
import LoggingService from '../service/LoggingService';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.handleRetry = () => {
            this.setState({ hasError: false, error: undefined });
        };
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        return __awaiter(this, void 0, void 0, function* () {
            yield LoggingService.logError(error, 'ErrorBoundary', { info: JSON.stringify(info) });
        });
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { style: { padding: '20px' }, children: [_jsx(MessageBar, { messageBarType: MessageBarType.error, isMultiline: true, styles: {
                            root: {
                                backgroundColor: "#FBE9E7",
                                border: "1px solid #F4F4F4",
                                color: "#0F5132",
                                fontWeight: "normal",
                                marginBottom: 20,
                            },
                            icon: {
                                color: "#D7422F",
                                fontSize: 28,
                                height: 28,
                                width: 28,
                                alignSelf: "center",
                            },
                        }, children: _jsxs("div", { children: [_jsx("strong", { children: "Something went wrong" }), _jsx("div", { children: "An unexpected error occurred. Please try refreshing the page or contact support if the problem persists." }), this.state.error && (_jsxs("div", { style: { marginTop: 10, fontSize: '12px', color: '#666' }, children: ["Error: ", this.state.error.message] }))] }) }), _jsx(PrimaryButton, { text: "Try Again", onClick: this.handleRetry, styles: {
                            root: {
                                backgroundColor: "#0F1E32",
                                borderRadius: 4,
                            },
                            rootHovered: { backgroundColor: "#0F1E32" },
                            rootPressed: { backgroundColor: "#0F1E32" },
                        } })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
